<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';
	import { onMount } from 'svelte';

	export let configs: ConfigsEntity[];
	const appId = configs[0].values.app_id || '';

	// This injects into the dom, but the widget do not show, same happens on bluesuede
	// The docs are a bit unclear but https://www.intercom.com/help/en/articles/2546256-why-can-t-i-see-the-messenger
	// Looks like they wont sow this on a trail account unless you add a Credit card

	onMount(() => {
		let intercomSettings = document.getElementById('intercomSettings');
		if (intercomSettings) {
			intercomSettings.innerText = `window.intercomSettings = {api_base: 'https://api-iam.intercom.io',app_id: '${appId}'}`;
		}
		let intercom = document.getElementById('intercom');
		if (intercom) {
			intercom.innerText = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/zrg3oae7';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;
		}
	});
</script>

<svelte:head>
	<script id="intercomSettings"></script>
	<script id="intercom"></script>
</svelte:head>
